import moment from 'moment'

const prepareShow = parking => {
  parking.date_go_in = moment(parking.date_go_in, 'YYYYMMDD').format('DD/MM/YYYY')
  parking.date_go_out = moment(parking.date_go_out, 'YYYYMMDD').format('DD/MM/YYYY')

  return parking
}

const prepareSearch = (search) => {
  search.generic = search.generic
  return search
}

export default {
  prepareShow,
  prepareSearch,
  doFilterSearch () {
    this.setPage(1)
  },
  doClearSearch () {
    this.search.generic = null
    this.doLoadAll()
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/livings/index/resources/methods.js